import {isEmpty, vuepayAlert} from "../../utility";
import {getData, LOGIN} from "../../storage";
import assets from "../../assets";

const getReplyListAPI = (props, comment_id, pageCount) => {
    let page = pageCount ? pageCount : 1;

    getData(LOGIN).then((data) => {
        if (!isEmpty(data) && data.api_token) {
            props.getReplyList(
                data.token,
                data.api_token,
                comment_id, pageCount
            );
        } else {
            //only run this if the searchQuery is blank
            props.getReplyList(
                null,
                null,
                comment_id, pageCount
            );
        }
    });
};

const createReplyAPI = (props, comment_id,postData) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data) && data.api_token) {
            props.createReply(
                data.token,
                data.api_token,
                comment_id,
                postData
            );
        }
    });
};

const updateReplyAPI = (props, Reply_id,postData) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data) && data.api_token) {
            props.updateReply(
                data.token,
                data.api_token,
                Reply_id,
                postData
            );
        }
    });
};

const deleteReplyAPI = (props, Reply_id) => {
    getData(LOGIN).then((data) => {
        if (!isEmpty(data) && data.api_token) {
            props.deleteReply(
                data.token,
                data.api_token,
                Reply_id
            );
        }
    });
};

const getType = (props) => {
    const isVideo = props.location.pathname.indexOf("video") > 0;
    const isGallery = props.location.pathname.indexOf("gallery") > 0;
    const isPicture = props.location.pathname.indexOf("picture") > 0;

    if (isVideo) {
        return "video";
    } else if (isGallery) {
        return "gallery";
    } else if (isPicture) {
        return "picture";
    }

    return "video"
}

const getOtherUserDropDownItem = (reportAction) => {
    return [{
        slug: 'report',
        title: "Report",
        icon: assets.messaging.dropdown.report,
        action: reportAction
    }]
}

const getUserDropDownItem = (editAction, deleteAction, reportAction) => {
    return [{
        slug: 'edit',
        title: "Edit",
        icon: assets.clipstore.more.editVideo,
        action: editAction
    }, {
        slug: 'delete',
        title: "Delete",
        icon: assets.clipstore.more.deleteVideo,
        action: deleteAction
    }, {
        slug: 'report',
        title: "Report",
        icon: assets.messaging.dropdown.report,
        action: reportAction
    }]
}

const apiUpdate = (nextProps,key,successCallback,resetCallback) => {

    if (nextProps[key] && nextProps[key].payload) {
        if (nextProps[key].payload.hasOwnProperty("success") &&
            nextProps[key].payload.success &&
            nextProps[key].payload.success.hasOwnProperty("data")) {
            successCallback();
            vuepayAlert("success", nextProps[key].payload.success.message)
        } else if ((nextProps[key].payload.hasOwnProperty("error") &&
            nextProps[key].payload.error &&
            nextProps[key].payload.error.hasOwnProperty("message"))) {
            vuepayAlert("error", nextProps[key].payload.error.message)
        }
        resetCallback();
    }
}
export default {
    getReplyListAPI,
    createReplyAPI,
    updateReplyAPI,
    deleteReplyAPI,
    getType,
    getOtherUserDropDownItem,
    getUserDropDownItem,
    apiUpdate
}